import {Component, OnDestroy, OnInit} from "@angular/core";
import {NavController, ModalController, Events} from "ionic-angular";
import {FormGroup, Validators, FormBuilder} from "@angular/forms";
import {User} from "../../shared/user/user.model";
import {validateCPR} from "../../../app/core/validators";
import {Language} from "../../shared/language/language.model";
import {JobType} from "../../shared/job-type/job-type.model";
import {AppAuth} from "../../../app/core/auth";
import {LanguageService} from "../../shared/language/language.service";
import {TranslateService} from "@ngx-translate/core";
import {ToastService} from "../../../app/core/toast.service";
import {JobTypeService} from "../../shared/job-type/job-type.service";
import {CountryCodesService} from "../../shared/country-codes.service";
import {LoginPage} from "../../login/login.page";
import {PlacesSearchModal} from "../../../app/components/places-search-modal/places-search-modal.component";
import {CvSubmitPage} from "../../cv-submit/cv-submit.page";
import {Speciality} from "../../shared/specialities/speciality.model";
import {SpecialitiesSelectModal} from "../../../app/components/specialities-select-modal/specialities-select-modal.component";
/*
 Generated class for the SignupPage page.

 See http://ionicframework.com/docs/v2/components/#navigation for more info on
 Ionic pages and navigation.
 */
@Component({
  selector: 'app-interpreter-signup',
  templateUrl: 'interpreter-signup.component.html'
})
export class InterpreterSignupComponent implements OnInit, OnDestroy {
  form: FormGroup;
  user: User = new User();
  private userControlsConfig = {
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
    name: ['', Validators.required],
    identity_number: ['', [Validators.required, validateCPR]],
    phone: ['', Validators.required],
    phone_country_code: ['', Validators.required],
    address: ['', Validators.required],
    gender: [null, Validators.required],
    languages: [null, Validators.required],
    job_types: [null, Validators.required],
    newsletter_opt_in: [null, Validators.required]
  };
  languages: Language[];
  job_types: JobType[];
  specialities: Speciality[];

  constructor(fb: FormBuilder,
              private modalCtrl: ModalController,
              private auth: AppAuth,
              private nav: NavController,
              private events: Events,
              private languageService: LanguageService,
              private translate: TranslateService,
              private toast: ToastService,
              private jobTypeService: JobTypeService,
              public countryCodesService: CountryCodesService
  ) {
    this.form = fb.group(this.userControlsConfig);
  }

  ngOnInit(): any {
    this.events.subscribe('place:selected', (place) => this.updateAddress(place));
    this.events.subscribe('speciality:selected', (interpreter) => this.onSpecialitySelected(interpreter));

    this.languageService.getLanguages()
      .subscribe(languages => this.languages = languages);

    this.jobTypeService.getJobTypes()
      .subscribe(types => this.job_types = types);
  }

  ngOnDestroy(){
    this.events.unsubscribe('place:selected');
    this.events.unsubscribe('speciality:selected');
  }

  goToLoginPage(){
    this.nav.push(LoginPage);
  }

  openPlacesSearchModal() {
    let modal = this.modalCtrl.create(PlacesSearchModal);
    modal.present();
  }

  updateAddress(place) {
    if (place.hasOwnProperty('formatted_address')) {
      this.user.address = place.formatted_address;
      this.user.address_latitude = place.geometry.location.lat();
      this.user.address_longitude = place.geometry.location.lng();
    }
  }

  onSpecialitySelected(speciality: any) {
    // Don't add duplicates
    let filtered = this.user.specialities.filter(user => user.id === speciality.id);
    if(filtered.length){
      return;
    }

    this.user.specialities.push(speciality);
  }

  signup() {
    if(!this.languagesSelected()){
      return false;
    }
    this.auth.signup(this.user, 'interpreter')
      .subscribe(success => this.nav.setPages([{page: CvSubmitPage}]));
  }

  private languagesSelected(){
    if(this.user.languages.length < 2){
      this.toast.show(this.translate.instant('profile.languages_required'));
      return false;
    }
    return true;
  }

  isPreselected(lang){
    // Danish should be always preselected
    return lang.id === 1;
  }

  removeSpeciality(index){
    this.user.specialities.splice(index, 1);
  }

  openSpecialitiesSelectModal(){
    let modal = this.modalCtrl.create(SpecialitiesSelectModal);
    modal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/signup/interpreter-signup/interpreter-signup.component.ts